import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useMemo } from 'react';
import Loadable from 'react-loadable';
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import { ArticleSearchComponent } from '@atlassian/article-search';
import { ExtensionMode, RESOURCE_TILES_EXTENSION_TYPE } from '@atlassian/company-hub-common';
import { CALLOUT_BANNER_EXTENSION_TYPE } from '@atlassian/page-topper-extension';
var CalloutBannerExtensionLoader = Loadable({
  loader: function () {
    var _loader = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return import( /* webpackChunkName: "@atlaskit-internal_page-topper-extension" */'@atlassian/page-topper-extension');
          case 2:
            return _context.abrupt("return", _context.sent.CalloutBannerExtension);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function loader() {
      return _loader.apply(this, arguments);
    }
    return loader;
  }(),
  loading: function loading() {
    return /*#__PURE__*/React.createElement(UFOLoadHold, {
      name: "page-topper-extension-loader"
    }, /*#__PURE__*/React.createElement(React.Fragment, null));
  }
});
var ResourceTilesExtensionLoader = Loadable({
  loader: function () {
    var _loader2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return import( /* webpackChunkName: "@atlaskit-internal_knowledge-cards-extension" */'@atlassian/knowledge-cards-extension');
          case 2:
            return _context2.abrupt("return", _context2.sent.ResourceTilesExtension);
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    function loader() {
      return _loader2.apply(this, arguments);
    }
    return loader;
  }(),
  loading: function loading() {
    return /*#__PURE__*/React.createElement(UFOLoadHold, {
      name: "resource-tiles-extension-loader"
    }, /*#__PURE__*/React.createElement(React.Fragment, null));
  }
});
var getCSMExtensionHandlers = function getCSMExtensionHandlers(contentId, PropsProvider) {
  var handlers = {};
  if (!contentId) {
    return handlers;
  }
  var defaultExtensionHandlerProps = {
    contentId: contentId,
    propsProvider: PropsProvider,
    mode: ExtensionMode.RENDERER,
    CustomSearchComponent: ArticleSearchComponent
  };

  // Callout banner Extension Handler
  handlers[CALLOUT_BANNER_EXTENSION_TYPE] = function (extension) {
    return /*#__PURE__*/React.createElement(CalloutBannerExtensionLoader, _extends({}, defaultExtensionHandlerProps, {
      extensionNode: extension
    }));
  };

  // Resource Tiles Extension Handler
  handlers[RESOURCE_TILES_EXTENSION_TYPE] = function (extension) {
    return /*#__PURE__*/React.createElement(ResourceTilesExtensionLoader, _extends({}, defaultExtensionHandlerProps, {
      extensionNode: extension,
      isInEditor: false
    }));
  };
  return handlers;
};
export var useProductExtensionHandlers = function useProductExtensionHandlers(props) {
  var contentId = props.contentId,
    PropsProvider = props.PropsProvider,
    product = props.product;
  var extensionHandlers = useMemo(function () {
    if (product === 'CSM') {
      return getCSMExtensionHandlers(contentId, PropsProvider);
    }

    // Future products can be added here with:
    // if (product === 'JSM') {
    //   return getJSMExtensionHandlers(contentId, PropsProvider);
    // }

    return {};
  }, [product, contentId, PropsProvider]);
  return extensionHandlers;
};